if (!customElements.get('arome-free-shipping')) {
  customElements.define('arome-free-shipping', class extends HTMLElement {
    connectedCallback() {
      this.fill = this.querySelector('.fill');
      this.cartIcon = this.querySelector('.cart');
      this.hint = this.querySelector('.hint');
      this.track = this.querySelector('.track');
      this.threshold = Number(this.dataset.threshold) * 100;
      this.updateHeight = () => {
        document.documentElement.style.setProperty('--arome-shipping-height', `${this.getBoundingClientRect().height}px`);
      };
      this.updateHeight();
      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(this.updateHeight);
        this.resizeObserver.observe(this);
      }
      window.addEventListener('resize', this.updateHeight);
      if (!this.fill || !this.hint || !(this.threshold > 0)) return;
      this.refresh = this.refresh.bind(this);
      this.onVisibility = () => {
        if (!document.hidden) this.refresh();
      };
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.refresh);
      window.addEventListener('pageshow', this.refresh);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.refresh();
    }

    disconnectedCallback() {
      this.unsubscribe?.();
      window.removeEventListener('pageshow', this.refresh);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      window.removeEventListener('resize', this.updateHeight);
      document.documentElement.style.removeProperty('--arome-shipping-height');
    }

    async refresh() {
      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
          credentials: 'same-origin',
          signal: controller.signal,
          cache: 'no-store',
        });
        if (!response.ok) throw new Error('Cart request failed');
        const cart = await response.json();
        if (controller.signal.aborted || !this.isConnected) return;
        if (!Number.isFinite(cart.total_price) || cart.total_price < 0) throw new Error('Invalid cart total');
        this.dataset.cartCount = String(cart.item_count ?? (cart.total_price > 0 ? 1 : 0));
        if (cart.currency !== 'MXN') {
          this.fill.style.width = '0%';
          if (this.cartIcon) this.cartIcon.style.left = '0%';
          this.track?.setAttribute('aria-valuenow', '0');
          this.hint.textContent = 'Consulta las condiciones de envío gratis para México.';
          return;
        }
        document.dispatchEvent(new CustomEvent('arome:cart-state', { detail: { cart, threshold: this.threshold } }));
        const remaining = Math.max(0, this.threshold - cart.total_price);
        const progress = Math.min(100, (cart.total_price / this.threshold) * 100);
        this.fill.style.width = `${progress}%`;
        this.track?.setAttribute('aria-valuenow', String(Math.round(progress)));
        if (this.cartIcon) this.cartIcon.style.left = `${Math.min(progress, 96)}%`;
        const amount = new Intl.NumberFormat('es-MX', {
          style: 'currency', currency: 'MXN', minimumFractionDigits: remaining % 100 === 0 ? 0 : 2,
        }).format(remaining / 100);
        this.hint.textContent = remaining === 0
          ? '🎉 ¡Felicidades! Tu pedido ya tiene ENVÍO GRATIS.'
          : `🚚 ¡Ya casi! Te faltan ${amount} para obtener ENVÍO GRATIS.`;
      } catch (error) {
        if (error.name === 'AbortError' || controller.signal.aborted || !this.isConnected) return;
        this.fill.style.width = '0%';
        if (this.cartIcon) this.cartIcon.style.left = '0%';
        this.track?.setAttribute('aria-valuenow', '0');
        this.hint.textContent = 'Estamos actualizando el progreso de tu pedido.';
      }
    }
  });
}
